import styled from 'styled-components';
import { getSpace, px2rem, mq } from '../../../../stylesheets/tools';
import { fontFamilies } from '../../../../stylesheets/settings';

const StyledEducationLibraryStage = styled.section`
  .library-stage__breadcrumb {
    top: ${px2rem('100px')};

    .breadcrumb__back {
      &:before {
        content: none;
      }
    }
    .breadcrumb__link {
      display: block;
    }
  }
  .library-stage__container {
    position: relative;
    padding: ${px2rem('220px')} 0 ${px2rem('100px')} 0;
    overflow: hidden;

    ${mq('l')} {
      padding: ${px2rem('240px')} 0 ${px2rem('180px')} 0;
    }
    .library-stage__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      h1 {
        margin-bottom: ${getSpace('m')};

        ${mq('l')} {
          font-size: ${px2rem('82px')};
        }
      }

      .library-stage__copy {
        max-width: ${px2rem('600px')};
      }
    }
  }
  .library-stage__gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    background: rgb(88, 77, 248);
    background: linear-gradient(
      90deg,
      rgba(88, 77, 248, 1) 0%,
      rgba(50, 144, 245, 1) 51%,
      rgba(76, 162, 222, 1) 100%
    );
  }
  .library-stage__gradient-front {
    position: absolute;
    opacity: 0.8;
    width: 100%;
    height: 50%;
    top: 0;
    filter: blur(80px);
    background: rgb(131, 58, 180);
    background: linear-gradient(
      90deg,
      rgba(131, 58, 180, 0) 0%,
      rgba(235, 53, 209, 1) 20%,
      rgba(248, 173, 127, 1) 80%,
      rgba(248, 173, 127, 0) 100%
    );
  }
  .library-stage__tabs {
    margin-top: ${px2rem('-60px')};
    border-bottom: 3px solid;

    ${mq('l')} {
      margin-top: ${px2rem('-95px')};
    }

    .library-stage__tabs-grid {
      display: flex;
      transform: translateY(3px);
      justify-content: center;
      gap: ${px2rem('40px')};

      ${mq('l')} {
        gap: ${px2rem('100px')};
      }

      .library-stage__tab {
        position: relative;
        display: flex;
        transform: translateY(1px);

        .library-stage__tab-bg {
          width: 100%;
          height: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          border-top: 3px solid;
          background-color: white;
        }
        .library-stage__tab-bg:before,
        .library-stage__tab-bg:after {
          content: '';
          display: block;
          height: calc(100% + 3px);
          position: absolute;
          left: 0;
          bottom: 0;
          width: ${px2rem('30px')};
          background-color: white;
          border-top: 3px solid;

          ${mq('l')} {
            width: ${px2rem('80px')};
          }
        }

        .library-stage__tab-bg:before {
          border-top-left-radius: 6px;
          border-left: 3px solid;
          transform: translateX(-50%) skewX(-16deg);

          ${mq('l')} {
            border-top-left-radius: 20px;
          }
        }

        .library-stage__tab-bg:after {
          margin-left: auto;
          position: absolute;
          right: 0;
          border-top-right-radius: 6px;
          border-right: 3px solid;
          transform: translateX(50%) skewX(16deg);

          ${mq('l')} {
            border-top-right-radius: 20px;
          }
        }

        &:not(.tab--active) {
          .library-stage__tab-inner {
            color: black;
          }
        }

        .library-stage__tab-inner {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: ${px2rem('5px')};
          height: ${px2rem('60px')};
          z-index: 5;

          ${mq('l')} {
            gap: ${px2rem('10px')};
            height: ${px2rem('95px')};
          }

          .library-stage__tab-content {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;

            ${mq('m')} {
              padding: 0 ${getSpace('xxxs')};
            }
          }
          svg {
            display: block;
            height: ${px2rem('50px')};
            width: ${px2rem('50px')};

            ${mq('m')} {
              height: ${px2rem('34px')};
              width: ${px2rem('34px')};
            }

            ${mq('l')} {
              height: ${px2rem('46px')};
              width: ${px2rem('46px')};
            }
          }
        }
        .library-stage__tab-button {
          text-align: left;
          color: currentColor;

          ${mq('xs')} {
            padding-right: ${px2rem('10px')};
          }

          ${mq('m')} {
            padding-right: 0;
          }

          .library-stage__tab-title {
            font-size: ${px2rem('18px')};
            font-family: ${fontFamilies.default};
            text-transform: uppercase;

            ${mq('m')} {
              white-space: nowrap;
            }
            ${mq('l')} {
              font-size: ${px2rem('38px')};
            }
            ${mq('xl')} {
              font-size: ${px2rem('28px')};
            }
          }
          .library-stage__tab-title-stretched {
            position: absolute;
            inset: 0;
          }
        }

        &:last-child {
          svg {
            position: relative;
            left: 7px; // optically fixed icon position

            ${mq('xl')} {
              left: ${getSpace('xxxs')};
            }
          }
        }
      }
    }
  }
`;

export default StyledEducationLibraryStage;
